import type { AdditionalField } from 'app/store/project/addition-fields/addition-fields.reducer';

export function defaultAdditionalFieldNumber(field: AdditionalField): number | undefined {
  return field.defaultLabel?.original === field.label ? field.defaultLabel.number : undefined;
}
